module.exports = __webpack_public_path__ + "img/mlp_video_thumbnail.3b89339e.jpg";